import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import type AppState from 'src/types/appState';

import { useQueryParams } from '../useQueryParams';

export const useUpdateDraftIdParam = () => {
  const { draftId } = useSelector(
    (state: AppState) => ({
      draftId: state.session.draftId,
    }),
    shallowEqual,
  );

  const { setParams } = useQueryParams();

  useEffect(() => {
    if (draftId) {
      setParams([
        {
          name: 'draftid',
          value: draftId,
        },
        {
          name: 'jobid',
          value: null,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftId]);
};
